<template>
  <div>
    <b-progress class="mt-2" :max="100" show-value height="4rem">
      <b-progress-bar :style="`background-color: ${person.color}`" v-for="person in lista_encuestas" :key="person.id" :value="person.date_one">
        <div>{{ person.options }}</div>
        <div>{{ person.date_one}}%</div>
      </b-progress-bar>
    </b-progress>
    <div class="row">
      <div class="col-12 col-md-12">
        <div class="note">
          Margen de error +- 3.1%
        </div>
      </div>      
    </div>
  </div>
  
</template>

<script>

import { kebabCase, maxBy } from 'lodash'
import * as d3 from 'd3'

export default {
  name: 'BarStacked',
  props: {
    lista_encuestas: Array
  },
  methods: {
    kebabCase,
    CalcularBarra(porcentaje) {
      let max = maxBy(this.lista_encuestas, "date_one")
      let scale = d3.scaleLinear().domain([0, max.date_one]).range([0, 100])
      return scale(parseInt(porcentaje))
    }
  }
}
</script>
